module.exports = __webpack_public_path__ + "static/mylkguys-1de2bdef865bb69b567d583129aa4271.jpg";